import React from 'react';
import { toast } from 'react-toastify';
import { toastConfig } from './DisplayGlobalMessage';

// Callback to show the error modal - set by ErrorReportProvider
let showErrorModalCallback = null;

// Flag check function - set by ErrorReportProvider
let isFeatureEnabled = () => false;

/**
 * Register the error modal callback (called by ErrorReportProvider)
 */
export const registerErrorModalCallback = (callback, checkEnabled) => {
  showErrorModalCallback = callback;
  isFeatureEnabled = checkEnabled;
};

/**
 * Unregister the error modal callback (called on unmount)
 */
export const unregisterErrorModalCallback = () => {
  showErrorModalCallback = null;
  isFeatureEnabled = () => false;
};

/**
 * Toast content with View button
 */
const ErrorToastContent = ({ message, errorDetails, closeToast }) => {
  const handleView = (e) => {
    e.stopPropagation();
    if (showErrorModalCallback) {
      showErrorModalCallback(errorDetails);
    }
    closeToast();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={handleView}
        style={{
          padding: '4px 12px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '500',
        }}
      >
        View
      </button>
    </div>
  );
};

/**
 * Display an error toast with optional "View" button for reporting
 *
 * @param {string} message - The error message to display
 * @param {Object} errorDetails - Additional error details (endpoint, stackTrace, etc.)
 * @param {Object} customConfig - Optional custom toast configuration
 */
export default function displayErrorWithReport(message, errorDetails = {}, customConfig = {}) {
  const fullErrorDetails = {
    message,
    stackTrace: errorDetails.stackTrace || null,
    endpoint: errorDetails.endpoint || null,
    timestamp: new Date().toISOString(),
  };

  // If feature is enabled and callback is registered, show toast with View button
  if (isFeatureEnabled() && showErrorModalCallback) {
    const finalConfig = {
      ...toastConfig,
      ...customConfig,
      type: 'error',
      autoClose: 5000, // Longer duration to allow clicking View
      closeOnClick: false, // Don't close on click so user can click View button
    };

    return toast(
      ({ closeToast }) => (
        <ErrorToastContent
          message={message}
          errorDetails={fullErrorDetails}
          closeToast={closeToast}
        />
      ),
      finalConfig
    );
  }

  // Fallback to regular error toast
  const finalConfig = {
    ...toastConfig,
    ...customConfig,
    type: 'error',
  };

  return toast(message, finalConfig);
}
